module.exports = [{
      plugin: require('/var/www/ep-frontpage-develop-1550920685/node_modules/gatsby-plugin-jss/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/var/www/ep-frontpage-develop-1550920685/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
